import type {AddComponentTypeOptions, ComponentDefinition} from 'grapesjs';
import {asteriskHtml, createBaseBoxComponent} from '@FormMakerReact/components/create-base-box-component';
import {POSTERMYWALL_FORM_SPACER_TYPE} from '@FormMakerReact/components/postermywall-form-spacer/postermywall-form-spacer';
import {POSTERMYWALL_FORM_TEXT_TYPE} from '@FormMakerReact/components/postermywall-form-text/postermywall-form-text';
import {POSTERMYWALL_DAY_INPUT_TYPE} from '@FormMakerReact/components/postermywall-day-input/postermywall-day-input';
import {POSTERMYWALL_MONTH_INPUT_TYPE} from '@FormMakerReact/components/postermywall-month-input/postermywall-month-input';
import {POSTERMYWALL_YEAR_INPUT_TYPE} from '@FormMakerReact/components/postermywall-year-input/postermywall-year-input';

export const POSTERMYWALL_BIRTHDAY_BOX_TYPE = 'postermywall-birthday-box';

function birthdaySubField(cssClass: string, inputType: string, style: Record<string, string> = {}): ComponentDefinition {
  return {
    tagName: 'div',
    classes: cssClass,
    style,
    components: [{type: inputType}],
  };
}

export const POSTERMYWALL_BIRTHDAY_BOX: AddComponentTypeOptions = createBaseBoxComponent({
  boxType: POSTERMYWALL_BIRTHDAY_BOX_TYPE,
  dataMarkerAttribute: 'data-is-pmw-form-birthday-box',
  components: [
    {type: POSTERMYWALL_FORM_SPACER_TYPE},
    {type: POSTERMYWALL_FORM_TEXT_TYPE, content: `<strong>Birthday${asteriskHtml()}</strong>`},
    {
      tagName: 'div',
      style: {display: 'flex'},
      classes: 'pmw-birthday-box-separation-container',
      components: [
        birthdaySubField('day', POSTERMYWALL_DAY_INPUT_TYPE, {'margin-right': '10px'}),
        birthdaySubField('month', POSTERMYWALL_MONTH_INPUT_TYPE, {'margin-right': '10px'}),
        birthdaySubField('year', POSTERMYWALL_YEAR_INPUT_TYPE),
      ],
    },
  ],
});
